import type { DashboardDataset, ImportWorkerEvent } from '../types';

export interface ImportProgress {
  progress: number;
  message: string;
}

export const importExcel = async (
  file: File,
  onProgress?: (progress: ImportProgress) => void,
): Promise<DashboardDataset> => {
  if (!/\.(xlsx|xlsm|xls)$/i.test(file.name)) throw new Error('请上传 .xlsx、.xlsm 或 .xls 文件');
  if (file.size > 60 * 1024 * 1024) throw new Error('文件超过 60 MB，请先精简后再上传');
  onProgress?.({ progress: 5, message: '正在读取文件' });
  const buffer = await file.arrayBuffer();
  const worker = new Worker(new URL('../workers/excel.worker.ts', import.meta.url), { type: 'module' });
  return new Promise((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<ImportWorkerEvent>) => {
      if (event.data.type === 'progress') onProgress?.(event.data);
      if (event.data.type === 'success') {
        worker.terminate();
        resolve(event.data.dataset);
      }
      if (event.data.type === 'error') {
        worker.terminate();
        reject(new Error(event.data.message));
      }
    };
    worker.onerror = (event) => {
      worker.terminate();
      reject(new Error(event.message || 'Excel 解析线程异常'));
    };
    worker.postMessage({ buffer, fileName: file.name }, [buffer]);
  });
};
